var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 14.875V11.3333H3.54167V13.4583H5.66667V14.875H2.125ZM11.3333 14.875V13.4583H13.4583V11.3333H14.875V14.875H11.3333ZM8.5 13.4583C7.13056 13.4583 5.96181 12.9743 4.99375 12.0063C4.02569 11.0382 3.54167 9.86944 3.54167 8.5C3.54167 7.13056 4.02569 5.96181 4.99375 4.99375C5.96181 4.02569 7.13056 3.54167 8.5 3.54167C9.86944 3.54167 11.0382 4.02569 12.0063 4.99375C12.9743 5.96181 13.4583 7.13056 13.4583 8.5C13.4583 9.86944 12.9743 11.0382 12.0063 12.0063C11.0382 12.9743 9.86944 13.4583 8.5 13.4583ZM8.5 12.0417C9.47986 12.0417 10.3152 11.6962 11.0061 11.0054C11.6969 10.3145 12.0421 9.47939 12.0417 8.5C12.0412 7.52061 11.6958 6.68549 11.0054 5.99463C10.315 5.30376 9.47986 4.95833 8.5 4.95833C7.52014 4.95833 6.68501 5.30376 5.99463 5.99463C5.30424 6.68549 4.95881 7.52061 4.95833 8.5C4.95786 9.47939 5.30329 10.3147 5.99463 11.0061C6.68596 11.6974 7.52108 12.0426 8.5 12.0417ZM2.125 5.66667V2.125H5.66667V3.54167H3.54167V5.66667H2.125ZM13.4583 5.66667V3.54167H11.3333V2.125H14.875V5.66667H13.4583Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.9da0241934d1826b99b5b90f456ae426.svg";
export { ForwardRef as ReactComponent };